// removed by extract-text-webpack-plugin
module.exports = {"emphasis":"_2kyTm1ZvCl"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/containers/secure/Dashboard/MyWayForwardSummary/MyWayForwardSummary-CapOne.module.less
// module id = 981
// module chunks = 3